import {
  LightbulbOutlined, Lightbulb,
  WbIncandescentOutlined, WbIncandescent,
  Palette,
  MeetingRoom,
  Garage,
  PowerOutlined, Power, PowerSettingsNew,
  BlindsClosed, Blinds,
  Thermostat,
  AutoAwesome,
  NotificationsActive,
  VolumeUp,
  AirOutlined, Air,
  GrassOutlined, Grass,
  SettingsInputComponent,
  Security, SecurityOutlined,
  Lock, LockOutlined,
  Videocam, VideocamOutlined,
  Sensors, SensorsOutlined,
  WaterDrop, WaterDropOutlined,
  AcUnit, AcUnitOutlined,
  ElectricalServices, ElectricalServicesOutlined,
  Outlet, OutletOutlined,
  Window, WindowOutlined,
  Roofing, RoofingOutlined,
  SolarPower, SolarPowerOutlined,
  BatteryChargingFull,
  EvStation,
  Bolt, BoltOutlined,
  Shower, ShowerOutlined,
  Kitchen, KitchenOutlined,
  Microwave, MicrowaveOutlined,
  LocalLaundryService,
  Iron, IronOutlined,
  Tv, TvOutlined,
  Speaker, SpeakerOutlined,
  Router, RouterOutlined,
  Wifi, WifiOutlined,
  Doorbell, DoorbellOutlined,
  CameraOutdoor, CameraOutdoorOutlined,
  FireExtinguisher,
  SmokeFree,
  SmokingRooms,
  TungstenOutlined, Tungsten,
  FluorescentOutlined, Fluorescent,
  LightMode, LightModeOutlined,
  NightlightOutlined, Nightlight,
  Yard, YardOutlined,
  Park, ParkOutlined,
  Pool, PoolOutlined,
  HotTub, HotTubOutlined,
  FitnessCenter, FitnessCenterOutlined,
  Elevator, ElevatorOutlined,
  Escalator, EscalatorOutlined,
  ModeStandby,
  PowerOff
} from '@mui/icons-material';

// Full catalogue of domotics-relevant MUI icons
// Key = MUI component name (stored in DB), Value = { component, label }
export const muiIconCatalogue = {
  // Lighting
  LightbulbOutlined: { component: LightbulbOutlined, label: 'Light Bulb' },
  Lightbulb: { component: Lightbulb, label: 'Light Bulb (Filled)' },
  WbIncandescentOutlined: { component: WbIncandescentOutlined, label: 'Dimmable Light' },
  WbIncandescent: { component: WbIncandescent, label: 'Dimmable Light (Filled)' },
  TungstenOutlined: { component: TungstenOutlined, label: 'Tungsten' },
  Tungsten: { component: Tungsten, label: 'Tungsten (Filled)' },
  FluorescentOutlined: { component: FluorescentOutlined, label: 'Fluorescent' },
  Fluorescent: { component: Fluorescent, label: 'Fluorescent (Filled)' },
  LightMode: { component: LightMode, label: 'Light Mode' },
  LightModeOutlined: { component: LightModeOutlined, label: 'Light Mode (Outline)' },
  NightlightOutlined: { component: NightlightOutlined, label: 'Night Light' },
  Nightlight: { component: Nightlight, label: 'Night Light (Filled)' },
  Palette: { component: Palette, label: 'Color' },

  // Power & Electrical
  PowerOutlined: { component: PowerOutlined, label: 'Power' },
  Power: { component: Power, label: 'Power (Filled)' },
  PowerSettingsNew: { component: PowerSettingsNew, label: 'Power Button' },
  PowerOff: { component: PowerOff, label: 'Power Off' },
  ModeStandby: { component: ModeStandby, label: 'Standby' },
  Outlet: { component: Outlet, label: 'Outlet' },
  OutletOutlined: { component: OutletOutlined, label: 'Outlet (Outline)' },
  ElectricalServices: { component: ElectricalServices, label: 'Electrical' },
  ElectricalServicesOutlined: { component: ElectricalServicesOutlined, label: 'Electrical (Outline)' },
  Bolt: { component: Bolt, label: 'Bolt' },
  BoltOutlined: { component: BoltOutlined, label: 'Bolt (Outline)' },
  BatteryChargingFull: { component: BatteryChargingFull, label: 'Battery' },
  EvStation: { component: EvStation, label: 'EV Station' },
  SolarPower: { component: SolarPower, label: 'Solar Power' },
  SolarPowerOutlined: { component: SolarPowerOutlined, label: 'Solar Power (Outline)' },

  // Doors & Access
  MeetingRoom: { component: MeetingRoom, label: 'Door' },
  Garage: { component: Garage, label: 'Garage' },
  Lock: { component: Lock, label: 'Lock' },
  LockOutlined: { component: LockOutlined, label: 'Lock (Outline)' },
  Doorbell: { component: Doorbell, label: 'Doorbell' },
  DoorbellOutlined: { component: DoorbellOutlined, label: 'Doorbell (Outline)' },
  Elevator: { component: Elevator, label: 'Elevator' },
  ElevatorOutlined: { component: ElevatorOutlined, label: 'Elevator (Outline)' },
  Escalator: { component: Escalator, label: 'Escalator' },
  EscalatorOutlined: { component: EscalatorOutlined, label: 'Escalator (Outline)' },

  // Climate & Ventilation
  Thermostat: { component: Thermostat, label: 'Thermostat' },
  AcUnit: { component: AcUnit, label: 'Air Conditioning' },
  AcUnitOutlined: { component: AcUnitOutlined, label: 'Air Conditioning (Outline)' },
  AirOutlined: { component: AirOutlined, label: 'Ventilation' },
  Air: { component: Air, label: 'Ventilation (Filled)' },

  // Window & Blinds
  BlindsClosed: { component: BlindsClosed, label: 'Blinds' },
  Blinds: { component: Blinds, label: 'Blinds (Open)' },
  Window: { component: Window, label: 'Window' },
  WindowOutlined: { component: WindowOutlined, label: 'Window (Outline)' },
  Roofing: { component: Roofing, label: 'Roof' },
  RoofingOutlined: { component: RoofingOutlined, label: 'Roof (Outline)' },

  // Security & Safety
  Security: { component: Security, label: 'Security' },
  SecurityOutlined: { component: SecurityOutlined, label: 'Security (Outline)' },
  Videocam: { component: Videocam, label: 'Camera' },
  VideocamOutlined: { component: VideocamOutlined, label: 'Camera (Outline)' },
  CameraOutdoor: { component: CameraOutdoor, label: 'Outdoor Camera' },
  CameraOutdoorOutlined: { component: CameraOutdoorOutlined, label: 'Outdoor Camera (Outline)' },
  NotificationsActive: { component: NotificationsActive, label: 'Alarm' },
  FireExtinguisher: { component: FireExtinguisher, label: 'Fire Extinguisher' },
  SmokeFree: { component: SmokeFree, label: 'Smoke Detector' },
  SmokingRooms: { component: SmokingRooms, label: 'Smoke' },

  // Water
  WaterDrop: { component: WaterDrop, label: 'Water' },
  WaterDropOutlined: { component: WaterDropOutlined, label: 'Water (Outline)' },
  Shower: { component: Shower, label: 'Shower' },
  ShowerOutlined: { component: ShowerOutlined, label: 'Shower (Outline)' },
  Pool: { component: Pool, label: 'Pool' },
  PoolOutlined: { component: PoolOutlined, label: 'Pool (Outline)' },
  HotTub: { component: HotTub, label: 'Hot Tub' },
  HotTubOutlined: { component: HotTubOutlined, label: 'Hot Tub (Outline)' },
  GrassOutlined: { component: GrassOutlined, label: 'Irrigation' },
  Grass: { component: Grass, label: 'Irrigation (Filled)' },

  // Audio & Media
  VolumeUp: { component: VolumeUp, label: 'Audio' },
  Speaker: { component: Speaker, label: 'Speaker' },
  SpeakerOutlined: { component: SpeakerOutlined, label: 'Speaker (Outline)' },
  Tv: { component: Tv, label: 'TV' },
  TvOutlined: { component: TvOutlined, label: 'TV (Outline)' },

  // Appliances
  Kitchen: { component: Kitchen, label: 'Kitchen' },
  KitchenOutlined: { component: KitchenOutlined, label: 'Kitchen (Outline)' },
  Microwave: { component: Microwave, label: 'Microwave' },
  MicrowaveOutlined: { component: MicrowaveOutlined, label: 'Microwave (Outline)' },
  LocalLaundryService: { component: LocalLaundryService, label: 'Laundry' },
  Iron: { component: Iron, label: 'Iron' },
  IronOutlined: { component: IronOutlined, label: 'Iron (Outline)' },

  // Network
  Router: { component: Router, label: 'Router' },
  RouterOutlined: { component: RouterOutlined, label: 'Router (Outline)' },
  Wifi: { component: Wifi, label: 'WiFi' },
  WifiOutlined: { component: WifiOutlined, label: 'WiFi (Outline)' },
  Sensors: { component: Sensors, label: 'Sensor' },
  SensorsOutlined: { component: SensorsOutlined, label: 'Sensor (Outline)' },

  // Outdoor & Recreation
  Yard: { component: Yard, label: 'Yard' },
  YardOutlined: { component: YardOutlined, label: 'Yard (Outline)' },
  Park: { component: Park, label: 'Park' },
  ParkOutlined: { component: ParkOutlined, label: 'Park (Outline)' },
  FitnessCenter: { component: FitnessCenter, label: 'Fitness' },
  FitnessCenterOutlined: { component: FitnessCenterOutlined, label: 'Fitness (Outline)' },

  // Misc
  AutoAwesome: { component: AutoAwesome, label: 'Scene' },
  SettingsInputComponent: { component: SettingsInputComponent, label: 'Other' }
};

// Flat array for the icon picker
export const iconCatalogueList = Object.entries(muiIconCatalogue).map(
  ([key, { component, label }]) => ({ key, component, label })
);

/**
 * Resolve an MUI icon name to a React component.
 * Falls back to SettingsInputComponent if not found.
 */
export const getIconComponent = (muiIconName) => {
  const entry = muiIconCatalogue[muiIconName];
  return entry ? entry.component : SettingsInputComponent;
};
